import { useStrictLocalization } from "@faire/web/common/localization";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { AppDownloadPromoBanner } from "@faire/retailer/components/MobileAppPromoBanner/AppDownloadPromoBanner";

export const AppPromotionBanner: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const { onCTAClick, layoutElement, requestId } = React.useContext(Context);

  const handleClick = () => {
    onCTAClick?.(
      layoutElement.on_click_event_name ?? "AppPromotionBanner",
      requestId
    );
  };

  return (
    <>
      <Spacer
        height={{
          mobileAndAbove: "3x",
          tabletAndAbove: 0,
        }}
      />
      <AppDownloadPromoBanner
        header={useHeaderText()}
        body={strictLocalize({
          defaultMessage:
            "Enter your phone number and we'll text you a link to download the Faire app.",
          description: {
            text: "Marketing for mobile app",
            img: "https://cdn.faire.com/fastly/1966702fcf67fabb50a89d052f2c0b273d1f66aeff28e9094a46f9283447e7dd.png",
          },
        })}
        onClick={handleClick}
      />
    </>
  );
};

const useHeaderText = () => {
  const { strictLocalize } = useStrictLocalization();
  return strictLocalize({
    defaultMessage: "Shop thousands of brands on the go",
    description: {
      text: "Marketing for mobile app",
      img: "https://cdn.faire.com/fastly/1966702fcf67fabb50a89d052f2c0b273d1f66aeff28e9094a46f9283447e7dd.png",
    },
  });
};
